
angular.module("ainapp")
    .controller("bulkEmployeeSalaryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Bulk Employee Salary";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.PayrollSettings = {};
            MainService.GetPayrollSettings().then(function (response) {
                $scope.PayrollSettings = response.data;
            })

            $scope.Designations = {};
            MainService.DesignationsInDropdown().then(function (response) {
                $scope.Designations = response.data;
            })

            $scope.Departments = {};
            MainService.DepartmentsInDropdown().then(function (response) {
                $scope.Departments = response.data;
            })

            $scope.Grades = {};
            MainService.GradesInDropdown().then(function (response) {
                $scope.Grades = response.data;
            })

            $scope.calculateSalary = function (addData) {
                var totEarnings = 0;
                var totDeductions = 0;

                angular.forEach(addData.EmployeeSalaryDetails, function (a) {
                    if (a.Type == "Earnings") {
                        totEarnings = totEarnings + a.Calculated;
                    } else {
                        totDeductions = totDeductions + a.Calculated;
                    }
                })
                addData.NetSalary = totEarnings + addData.HolidayValue + addData.WeekOffValue;
                addData.TotalDeductions = totDeductions + addData.LateHourDeduction;
                addData.TotalSalary = (addData.NetSalary + addData.OvertimeSalary) - addData.TotalDeductions;

            }


            $scope.getEmployeeDetails = function (addData) {

                angular.forEach($scope.MonthsArr2, function (e) {
                    if (addData.Month == e.Name) {
                        $scope.monthNo = e.Id;
                        $scope.monthName = e.Name;
                    }
                })

                addData.Month = $scope.monthName;
                addData.Year = $scope.DateObj.Date.getFullYear();

                var d = new Date(addData.Year, $scope.monthNo, 0).getDate();
                addData.MonthDays = d;

                if (addData.EmployeeId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.CheckEmployeeSalaryByDate(addData.Year, addData.Month, addData.EmployeeId).then(function (response) {
                        if (response.data > 0) {

                            //$scope.loadVoucher(response.data);
                            toastr.warning("Salary Already Posted");

                        } else {

                            $.LoadingOverlay("show", {
                                image: "images/load.gif",
                            });

                            addData.EmployeeSalaryDetails = angular.copy(addData.PayrollComponents2);

                            addData.NetSalary = 0;
                            addData.LateHourDeduction = 0;
                            addData.TotalDeductions = 0;
                            addData.TotalSalary = 0;
                            addData.TotalDeductions = 0;
                            addData.OvertimeSalary = 0;
                            addData.OvertimeHours = 0;
                            addData.LateHours = 0;
                            addData.PaidLeavs = 0;
                            addData.WeeklyOff = 0;
                            addData.Holidays = 0;
                            addData.LOP = 0;
                            addData.EffectiveDays = 0;
                            addData.HolidayHours = 0;
                            addData.HolidayValue = 0;
                            addData.WeekOffHours = 0;
                            addData.WeekOffValue = 0;

                            MainService.GeEmployeePayrollById(addData.EmployeeId).then(function (response3) {
                                if (response3.data) {

                                    $scope.AttandanceSummary = response3.data;
                                    var basicsalary = response3.data.BasicSalary;
                                    var netSalary = response3.data.NetSalary;

                                    angular.forEach(addData.EmployeeSalaryDetails, function (e) {
                                        angular.forEach(response3.data.EmployeePayrolls, function (a) {
                                            if (a.PayrollComponentId == e.PayrollComponentId) {
                                                e.Actual = a.Amount;
                                                e.Calculated = a.Amount;
                                            }
                                        })
                                    })

                                    $.LoadingOverlay("show", {
                                        image: "images/load.gif",
                                    });
                                    MainService.GetEmployeeSalaryValues(addData.EmployeeId, addData.Year, $scope.monthNo, $scope.monthName)
                                        .then(function (response2) {
                                            if (response2.data) {

                                                $scope.AttandanceSummary = response2.data;

                                                addData.OvertimeHours = response2.data.OverTimeHours;
                                                addData.LateHours = Math.abs(response2.data.LateHours);

                                                addData.WeeklyOff = response2.data.TotalWeekOffs;
                                                addData.Holidays = response2.data.TotalHolidays;
                                                addData.DaysAttended = response2.data.TotalAttendedDays;

                                                addData.HolidayHours = response2.data.HolidayHours;
                                                addData.WeekOffHours = response2.data.WeekOffHours;

                                                addData.WeekOffValue = response2.data.WeekOffHours * response2.data.SpecialOvertimeValue;
                                                addData.WeekOffValue = Math.round(addData.WeekOffValue * 100) / 100;

                                                addData.HolidayValue = response2.data.HolidayHours * response2.data.HolidayOvertimeValue;
                                                addData.HolidayValue = Math.round(addData.HolidayValue * 100) / 100;


                                                var daysalary = 0;
                                                var hoursalary = 0;

                                                if (addData.OvertimeHours > 0) {

                                                    var whrs = $scope.PayrollSettings.DefaultWorkingHours;
                                                    var days = addData.MonthDays;

                                                    var totalearning = 0;
                                                    angular.forEach(addData.EmployeeSalaryDetails, function (e) {
                                                        if (e.Type == "Earnings") {
                                                            totalearning = totalearning + e.Calculated;
                                                        }

                                                    })
                                                    daysalary = totalearning / days;
                                                    hoursalary = daysalary / whrs;

                                                    if ($scope.PayrollSettings.OvertimePayType == "Fixed") {

                                                        addData.OvertimeSalary = addData.OvertimeHours * $scope.PayrollSettings.OvertimeValue;

                                                    } else if ($scope.PayrollSettings.OvertimePayType == "WorkHour") {

                                                        addData.OvertimeSalary = addData.OvertimeHours * hoursalary;

                                                    } else if ($scope.PayrollSettings.OvertimePayType == "Percentage") {

                                                        var per = hoursalary * ($scope.PayrollSettings.OvertimeValue / 100);
                                                        per = Math.round(per * 100) / 100;

                                                        addData.OvertimeSalary = addData.OvertimeHours * (hoursalary + per);
                                                    }

                                                    addData.LateHourDeduction = addData.LateHours * 10;

                                                }

                                                addData.PaidLeavs = response2.data.TotalPaidLeaves;
                                                addData.LOP = response2.data.TotalUnPaidLeaves;

                                                angular.forEach(addData.EmployeeSalaryDetails, function (e) {
                                                    angular.forEach(response2.data.EmployeeLeaveLogs, function (a) {
                                                        if (e.PayrollComponentId == a.PayrollComponentId) {

                                                            var ded = a.Count * daysalary;
                                                            var val = Math.round(ded * 100) / 100;
                                                            e.Actual = val;
                                                            e.Calculated = val;
                                                            e.Arrears = 0;
                                                            e.Adjustments = 0;

                                                        }
                                                    })
                                                })


                                                angular.forEach(addData.EmployeeSalaryDetails, function (e) {
                                                    angular.forEach(response2.data.EarningDeductionDetails, function (a) {
                                                        if (e.PayrollComponentId == a.PayrollComponentId) {
                                                            e.Actual = a.Amount;
                                                            e.Calculated = a.Amount;
                                                            e.Arrears = 0;
                                                            e.Adjustments = 0;
                                                        }
                                                    })
                                                })

                                                angular.forEach(addData.EmployeeSalaryDetails, function (e) {
                                                    angular.forEach(response2.data.EmployeeLoanDetails, function (a) {
                                                        if (e.PayrollComponentId == a.EmployeeLoan.LoanTypeId) {
                                                            e.Actual = a.Amount;
                                                            e.Calculated = a.Amount;
                                                            e.Arrears = 0;
                                                            e.Adjustments = 0;
                                                        }
                                                    })

                                                })


                                                addData.EffectiveDays = addData.DaysAttended;

                                                // addData.EffectiveDays = addData.DaysAttended + addData.PaidLeavs +
                                                //     addData.WeeklyOff + addData.Holidays;
                                                $scope.calculateSalary(addData);



                                            }
                                            $.LoadingOverlay("hide");
                                        }, function (err) {
                                            toastr.error($scope.LanguageData.NetworkError);
                                            $.LoadingOverlay("hide");
                                        });

                                    $scope.calculateSalary(addData);

                                }
                                $.LoadingOverlay("hide");
                            }, function (err) {
                                toastr.error($scope.LanguageData.NetworkError);
                                $.LoadingOverlay("hide");
                            });


                        }
                        $.LoadingOverlay("hide");
                    },
                        function (err) {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        });

                }


            }

            $scope.Init = function () {

                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                $scope.monthNo = month + 1;
                var monthName = $scope.MonthsArr[month].Name;

                var d = new Date(year, $scope.monthNo, 0).getDate();

                $scope.ViewVal = 0;

                MainService.GetNextEmployeeSalaryNo().then(function (response) {
                    $scope.VoucherNumber = response.data;
                })

                $scope.DateObj = {
                    Date: new Date(),
                    Year: year,
                    Month: monthName,
                    MonthDays: d,
                    DesignationId: "",
                    DepartmentId: "",
                    GradeId: "",
                }

                $scope.PayrollComponents = [];
                $scope.PayrollComponents2 = [];
                $scope.Employees = [];
                $scope.addDataList = [];




            }
            $scope.Init();

            $scope.loadEmployees = function () {

                MainService.EmployeesInBulkPayroll($scope.DateObj).then(function (response2) {
                    $scope.Employees = response2.data;

                    MainService.PayrollComponentsInSalary().then(function (response) {
                        $scope.PayrollComponents = response.data;

                        angular.forEach($scope.Employees, function (a) {
                            var addData = {
                                VoucherNumber: "",
                                Date: new Date(),
                                Remarks: "",
                                Year: $scope.DateObj.Year,
                                Month: $scope.DateObj.Month,
                                EmployeeId: a.Id,
                                Employee: a,
                                NetSalary: 0,
                                OvertimeSalary: 0,
                                TotalDeductions: 0,
                                TotalSalary: 0,
                                MonthDays: $scope.DateObj.MonthDays,
                                DaysAttended: 0,
                                PaidLeavs: 0,
                                WeeklyOff: 0,
                                Holidays: 0,
                                LOP: 0,
                                OvertimeHours: 0,
                                LateHourDeduction: 0,
                                LateHours: 0,
                                EffectiveDays: 0,
                                HolidayHours: 0,
                                HolidayValue: 0,
                                WeekOffHours: 0,
                                WeekOffValue: 0,
                                EmployeeSalaryDetails: [],
                                PayrollComponents2: [],
                            }

                            angular.forEach($scope.PayrollComponents, function (e) {

                                var detail = {
                                    Type: e.Type,
                                    PayrollComponentId: e.Id,
                                    PayrollComponent: e,
                                    Actual: 0,
                                    Calculated: 0,
                                    Arrears: 0,
                                    Adjustments: 0,
                                }
                                addData.EmployeeSalaryDetails.push(detail);

                            })
                            addData.PayrollComponents2 = angular.copy(addData.EmployeeSalaryDetails);

                            $scope.addDataList.push(addData);
                        })

                        angular.forEach($scope.addDataList, function (addData) {
                            $scope.getEmployeeDetails(addData);
                        })


                    })

                })
            }

            $scope.refresh = function () {
                $scope.Init();
            }

            $scope.calcEffDays = function (addData) {

                addData.EffectiveDays = addData.DaysAttended;
                // addData.EffectiveDays = addData.DaysAttended + addData.PaidLeavs +
                //     addData.WeeklyOff + addData.Holidays;


            }

            $scope.getEmployeeDetailsAll = function () {

            }

            $scope.deleteRow = function (data) {

                var index = $scope.addDataList.indexOf(data);
                $scope.addDataList.splice(index, 1);
            }



            $scope.SaveData = function () {

                var IsInvalidSalary = false;
                angular.forEach($scope.addDataList, function (addData) {
                    addData.DateString = $scope.extractDate($scope.DateObj.Date);
                    if (addData.TotalSalary <= 0) {
                        IsInvalidSalary = true;
                        toastr.warning("Invalid Salary for " + addData.Employee.Name);
                    }
                })


                if (IsInvalidSalary) {
                    toastr.warning("Invalid Salary");
                } else {


                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddBulkEmployeeSalary($scope.addDataList).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });

                }
            }



        }])
